import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: 'calc(100% - 150px)',
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
};
